import React from 'react';

import i18n from '../../i18n';

import { TextField } from '@mui/material';

function stringifyValue(value) {
    if (value === undefined || value === null || value === '') return '';
    if (typeof value === 'string') {
        try {
            return JSON.stringify(JSON.parse(value), null, 2);
        } catch {
            return value;
        }
    }
    try {
        return JSON.stringify(value, null, 2);
    } catch {
        return String(value);
    }
}

export default class DialogJsonField extends React.Component {
    constructor(props) {
        super(props);
        this.originalIsString = typeof props.value === 'string';
        this.state = {
            text: stringifyValue(props.value),
            error: false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && !this.isFocused) {
            const next = stringifyValue(this.props.value);
            if (next !== this.state.text) {
                this.setState({ text: next, error: false });
            }
        }
    }

    handleChange = (event) => {
        const text = event.target.value;
        this.setState({ text });

        if (!text.trim()) {
            this.setState({ error: false });
            this.props.onChange(this.props.field.id, null);
            return;
        }

        try {
            const parsed = JSON.parse(text);
            this.setState({ error: false });
            const asString =
                this.props.field.jsonAsString ?? this.originalIsString;
            this.props.onChange(
                this.props.field.id,
                asString ? JSON.stringify(parsed) : parsed
            );
        } catch {
            this.setState({ error: true });
        }
    };

    handleFocus = () => {
        this.isFocused = true;
    };

    handleBlur = () => {
        this.isFocused = false;
        if (!this.state.error && this.state.text.trim()) {
            this.setState({ text: stringifyValue(this.props.value) });
        }
    };

    render() {
        const { field, disabled } = this.props;
        const translatedName = i18n.t(`columns.${field.label}`);
        const onlyRead = !!field.onlyRead;

        return (
            <TextField
                key={field.id}
                margin="dense"
                id={field.id}
                label={translatedName}
                type="text"
                value={this.state.text}
                disabled={disabled || onlyRead}
                fullWidth
                multiline
                minRows={4}
                maxRows={16}
                error={this.state.error}
                helperText={
                    this.state.error ? i18n.t('errors.invalidJson') : ' '
                }
                onChange={this.handleChange}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                InputProps={{
                    sx: {
                        fontFamily: 'monospace',
                        fontSize: 13
                    }
                }}
            />
        );
    }
}